import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
// ----------------------------------------------------------------------
// Auth
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const SetPasswordPage = Loadable(lazy(() => import('../pages/auth/SetPasswordPage')));
export const ForgotPasswordPage = Loadable(lazy(() => import('../pages/auth/ForgotPasswordPage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const VerifyCodePage = Loadable(lazy(() => import('../pages/auth/VerifyCodePage')));
export const CheckEmailPage = Loadable(lazy(() => import('../pages/auth/CheckEmailPage')));
export const VerifyPhonePage = Loadable(lazy(() => import('../pages/auth/VerifyPhonePage')));
export const ResetPasswordVerifyPage = Loadable(
  lazy(() => import('../pages/auth/ResetPasswordVerifyPage'))
);
export const DownloadAppAfterSetupPage = Loadable(
  lazy(() => import('../pages/auth/DownloadAppAfterSetupPage'))
);
export const ReactivateAccountPage = Loadable(
  lazy(() => import('../pages/auth/ReactivateAccountPage'))
);
// Onboarding
export const WelcomePage = Loadable(lazy(() => import('../pages/onboarding/WelcomePage')));
export const FenceListPage = Loadable(lazy(() => import('../pages/onboarding/FenceListPage')));
export const FenceDetailPage = Loadable(lazy(() => import('../pages/onboarding/FenceDetailPage')));
export const DownloadAppPage = Loadable(lazy(() => import('../pages/onboarding/DownloadAppPage')));
// Home
export const SubscriptionPage = Loadable(lazy(() => import('../pages/home/SubscriptionPage')));
export const BlogDetailPage = Loadable(lazy(() => import('../pages/home/BlogDetailPage')));
export const BlogsPage = Loadable(lazy(() => import('../pages/home/BlogsPage')));
export const CheckoutPage = Loadable(lazy(() => import('../pages/home/CheckoutPage')));
export const ContactUsPage = Loadable(lazy(() => import('../pages/home/ContactUsPage')));
export const DownloadPage = Loadable(lazy(() => import('../pages/home/DownloadPage')));
export const EDFencePage = Loadable(lazy(() => import('../pages/home/EDFencePage')));
export const FaqsPage = Loadable(lazy(() => import('../pages/home/FaqsPage')));
export const OurFenceDetailPage = Loadable(lazy(() => import('../pages/home/OurFenceDetailPage')));
export const OurFencesPage = Loadable(lazy(() => import('../pages/home/OurFencesPage')));
export const OurStoryPage = Loadable(lazy(() => import('../pages/home/OurStoryPage')));
export const FeaturesPage = Loadable(lazy(() => import('../pages/home/FeaturesPage')));
export const MarketplacePage = Loadable(lazy(() => import('../pages/home/MarketplacePage')));
export const MarketplaceApplyPage = Loadable(
  lazy(() => import('../pages/home/MarketplaceApplyPage'))
);
export const QuotesAndMaterialsPage = Loadable(
  lazy(() => import('../pages/home/QuotesAndMaterialsPage'))
);
export const RealityARPage = Loadable(lazy(() => import('../pages/home/RealityARPage')));
export const LegalPage = Loadable(lazy(() => import('../pages/home/LegalPage')));
export const PrivacyPolicyPage = Loadable(lazy(() => import('../pages/home/PrivacyPolicyPage')));
export const TermsAndConditionsPage = Loadable(
  lazy(() => import('../pages/home/TermsAndConditionsPage'))
);
export const MeetingPage = Loadable(lazy(() => import('../pages/home/MeetingPage')));
export const ShopperPage = Loadable(lazy(() => import('../pages/home/ShopperPage')));
export const SignUpPage = Loadable(lazy(() => import('../pages/home/SignUpPage')));
export const StartPage = Loadable(
  lazy(
    // eslint-disable-next-line import/extensions
    () => import('../pages/home/StartPage.js')
  )
);
export const PublicQuotePage = Loadable(lazy(() => import('../pages/home/PublicQuotePage')));
export const PublicQuoteAgreementFlowPage = Loadable(
  lazy(() => import('../pages/home/PublicQuoteAgreementFlowPage'))
);
export const PublicMaterialListPage = Loadable(
  lazy(() => import('../pages/home/PublicMaterialListPage'))
);
export const PublicVirtualEstimatorPage = Loadable(
  // eslint-disable-next-line import/extensions, import/no-unresolved
  lazy(() => import('../pages/virtual-estimator/PublicVirtualEstimatorPage'))
);

// Dashboard
// Account
export const AccountPage = Loadable(lazy(() => import('../pages/dashboard/AccountPage')));

export const ChooseNewPlanPage = Loadable(
  lazy(() => import('../pages/dashboard/account/ChooseNewPlanPage'))
);
export const AlmostDonePage = Loadable(
  lazy(() => import('../pages/dashboard/account/AlmostDonePage'))
);

export const SwitchBillingPage = Loadable(
  lazy(() => import('../pages/dashboard/account/SwitchBillingPage'))
);

export const UpdatePaymentMethodPage = Loadable(
  lazy(() => import('../pages/dashboard/account/UpdatePaymentMethodPage'))
);

export const UpdateAccountPage = Loadable(
  lazy(() => import('../pages/dashboard/account/UpdateAccountPage'))
);

export const UpdateChildUsersPage = Loadable(
  lazy(() => import('../pages/dashboard/account/UpdateChildUsersPage'))
);

export const ConfirmCancelSubscriptionPage = Loadable(
  lazy(() => import('../pages/dashboard/account/ConfirmCancelSubscriptionPage'))
);
// Billing

export const BillingHistoryPage = Loadable(
  lazy(() => import('../pages/dashboard/billing/BillingHistoryPage'))
);
export const BillingDetailPage = Loadable(
  lazy(() => import('../pages/dashboard/billing/billingDetail/BillingDetailsPage'))
);
export const UserBlogsPage = Loadable(lazy(() => import('../pages/dashboard/blog/BlogsPage')));
export const UserBlogDetailPage = Loadable(
  lazy(() => import('../pages/dashboard/blog/BlogDetailPage'))
);
export const UserSupportPage = Loadable(
  lazy(() => import('../pages/dashboard/support/SupportPage'))
);
export const UserContactPage = Loadable(
  lazy(() => import('../pages/dashboard/contact/ContactPage'))
);
export const UserDownloadPage = Loadable(lazy(() => import('../pages/dashboard/DownloadPage')));
export const RecommendedDevicePage = Loadable(
  lazy(() => import('../pages/dashboard/RecommendedDevicePage'))
);
export const GettingStartedPage = Loadable(
  lazy(() => import('../pages/dashboard/GettingStartedPage'))
);
export const VirtualEstimatorPage = Loadable(
  // eslint-disable-next-line import/extensions, import/no-unresolved
  lazy(() => import('../pages/dashboard/VirtualEstimatorPage'))
);
export const VirtualEstimatorLeadsPage = Loadable(
  // eslint-disable-next-line import/extensions, import/no-unresolved
  lazy(() => import('../pages/dashboard/virtual-estimator/VirtualEstimatorLeadsPage'))
);
export const PricingBomPage = Loadable(
  lazy(() => import('../pages/dashboard/pricing-bom/PricingBomPage'))
);
export const PricingBomAccessGuard = Loadable(
  lazy(() => import('../pages/dashboard/pricing-bom/PricingBomAccessGuard'))
);
export const PricingBomProjectsPage = Loadable(
  lazy(() => import('../pages/dashboard/pricing-bom/PricingBomProjectsView'))
);
export const PricingBomQuotesPage = Loadable(
  lazy(() => import('../pages/dashboard/pricing-bom/PricingBomQuotesView'))
);
export const PricingBomMaterialsPage = Loadable(
  lazy(() => import('../pages/dashboard/pricing-bom/PricingBomMaterialsView'))
);
export const PricingBomEstimateDetailPage = Loadable(
  lazy(() => import('../pages/dashboard/pricing-bom/EstimateDetailPage'))
);
export const PricingBomFenceDetailPage = Loadable(
  lazy(() => import('../pages/dashboard/pricing-bom/PricingBomFenceDetailPage'))
);
export const PricingBomBrandingPage = Loadable(
  lazy(() => import('../pages/dashboard/pricing-bom/BrandingPage'))
);
// Congratulations Pages
export const PlanUpdateSuccessPage = Loadable(
  lazy(() => import('../pages/dashboard/account/congratulations/PlanUpdateSuccessPage'))
);
export const SwitchBillingSuccessPage = Loadable(
  lazy(() => import('../pages/dashboard/account/congratulations/SwitchBillingSuccessPage'))
);
export const UpdatePaymentMethodSuccessPage = Loadable(
  lazy(() => import('../pages/dashboard/account/congratulations/UpdatePaymentMethodSuccessPage'))
);
export const PauseSubscriptionSuccessPage = Loadable(
  lazy(() => import('../pages/dashboard/account/congratulations/PauseSubscriptionSuccessPage'))
);
export const CancelSubscriptionSuccessPage = Loadable(
  lazy(() => import('../pages/dashboard/account/congratulations/CancelSubscriptionSuccessPage'))
);
export const ResumeSubscriptionSuccessPage = Loadable(
  lazy(() => import('../pages/dashboard/account/congratulations/ResumeSubscriptionSuccessPage'))
);
// Manage My Fence
export const FenceFeaturedPage = Loadable(
  lazy(() => import('../pages/managefence/FenceFeaturedPage'))
);
export const FenceAddPage = Loadable(lazy(() => import('../pages/managefence/FenceAddPage')));
export const FenceDetailViewPage = Loadable(
  lazy(() => import('../pages/managefence/FenceDetailPage'))
);
export const FenceRemovePage = Loadable(lazy(() => import('../pages/managefence/FenceRemovePage')));
export const FenceRequestPage = Loadable(
  lazy(() => import('../pages/managefence/FenceRequestPage'))
);
// Error Pages
export const MaintenancePage = Loadable(lazy(() => import('../pages/MaintenancePage')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const Page500 = Loadable(lazy(() => import('../pages/Page500')));

// Landing Page - Add lazy loading for Home
export const HomePage = Loadable(lazy(() => import('../components/LandingPages/Home/Home')));

// Layouts - Lazy load heavy layouts (skip HomeLayout as it's needed immediately)
export const CompactLayout = Loadable(lazy(() => import('../layouts/compact')));
export const OnboardingLayout = Loadable(lazy(() => import('../layouts/onboarding')));
export const DashboardLayout = Loadable(lazy(() => import('../layouts/dashboard/DashboardLayout')));
export const ManageFenceLayout = Loadable(lazy(() => import('../layouts/managefence')));

// Tour Wrapper - Lazy load the fence tour functionality
export const FenceTourWrapper = Loadable(lazy(() => import('../components/FenceTourWrapper')));
